import { render, staticRenderFns } from "./ManageEdit.vue?vue&type=template&id=1dee6536"
import script from "./ManageEdit.vue?vue&type=script&lang=js"
export * from "./ManageEdit.vue?vue&type=script&lang=js"
import style0 from "./ManageEdit.vue?vue&type=style&index=0&id=1dee6536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports